/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2636__part-73
 */

"use strict"

import * as /* [auto-meaningful-name] */Module_235 from /* 235 */"./235"
var gm = [
  {
    type: "WidgetTitle",
    hasDisableOrVisible: true
  }, {
    type: "VisibleSwitch"
  }, [
    {
      type: "Color",
      label: "textColor"
    }, {
      type: "BackgroundColor"
    }
  ], {
    type: "Size",
    sizeRange: [[Module_235.l, Module_235.j], [Module_235.k, Module_235.i]]
  }, {
    type: "Coordinate"
  }
]
export { gm }
